import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const ThreeDffects = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='ThreeDffects' {...props}>
    <polyline fill='none' stroke='#000' strokeWidth='2' points='11 3 13 3 22 6 22 17 12 20.5 2 17 2 6.5 4 6 13 8.5 11 9 2 6.5' />
  </StyledIcon>
);
